var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	32747: () => (loadSingletonVersionCheckFallback("default", "react", [4,18,2,0], () => (__webpack_require__.e(7294).then(() => (() => (__webpack_require__(67294))))))),
	10056: () => (loadSingletonVersionCheckFallback("default", "react-dom", [4,18,2,0], () => (__webpack_require__.e(3935).then(() => (() => (__webpack_require__(73935))))))),
	32845: () => (loadStrictVersionCheckFallback("default", "styled-components", [4,5,2,0], () => (Promise.all([__webpack_require__.e(9163), __webpack_require__.e(9494), __webpack_require__.e(3882)]).then(() => (() => (__webpack_require__(29163))))))),
	61469: () => (loadStrictVersionCheckFallback("default", "@xsolla/design-system-icons", [4,1,26,4], () => (__webpack_require__.e(7731).then(() => (() => (__webpack_require__(17731))))))),
	93745: () => (loadStrictVersionCheckFallback("default", "@xsolla/design-system-themes", [4,1,27,2], () => (Promise.all([__webpack_require__.e(7723), __webpack_require__.e(478)]).then(() => (() => (__webpack_require__(7723))))))),
	70478: () => (loadStrictVersionCheckFallback("default", "colord", [1,2,9,3], () => (__webpack_require__.e(6765).then(() => (() => (__webpack_require__(16765))))))),
	36728: () => (loadStrictVersionCheckFallback("default", "@xsolla/design-system-feedback", [4,1,26,4], () => (Promise.all([__webpack_require__.e(3023), __webpack_require__.e(478), __webpack_require__.e(5212)]).then(() => (() => (__webpack_require__(11588))))))),
	34666: () => (loadStrictVersionCheckFallback("default", "react-router-dom", [4,6,21,3], () => (Promise.all([__webpack_require__.e(9250), __webpack_require__.e(9655), __webpack_require__.e(56)]).then(() => (() => (__webpack_require__(79655))))))),
	79817: () => (loadStrictVersionCheckFallback("default", "@xsolla/design-system-display", [4,1,27,2], () => (Promise.all([__webpack_require__.e(4400), __webpack_require__.e(3023), __webpack_require__.e(56), __webpack_require__.e(3745), __webpack_require__.e(6728), __webpack_require__.e(1933)]).then(() => (() => (__webpack_require__(94400))))))),
	66327: () => (loadStrictVersionCheckFallback("default", "lottie-web", [1,5,7,13], () => (__webpack_require__.e(1248).then(() => (() => (__webpack_require__(11248))))))),
	81664: () => (loadStrictVersionCheckFallback("default", "libphonenumber-js", [1,1,9,19], () => (__webpack_require__.e(5750).then(() => (() => (__webpack_require__(75750))))))),
	80866: () => (loadStrictVersionCheckFallback("default", "@xsolla/design-system-core", [4,1,27,2], () => (Promise.all([__webpack_require__.e(9250), __webpack_require__.e(2921), __webpack_require__.e(3023), __webpack_require__.e(3745), __webpack_require__.e(4666), __webpack_require__.e(2335)]).then(() => (() => (__webpack_require__(22921))))))),
	3191: () => (loadStrictVersionCheckFallback("default", "jwt-decode", [1,3,1,2], () => (__webpack_require__.e(6245).then(() => (() => (__webpack_require__(96245))))))),
	3256: () => (loadStrictVersionCheckFallback("default", "@xsolla/design-system-controls", [4,1,27,2], () => (Promise.all([__webpack_require__.e(292), __webpack_require__.e(3023), __webpack_require__.e(6781)]).then(() => (() => (__webpack_require__(10292))))))),
	7413: () => (loadStrictVersionCheckFallback("default", "@datadog/browser-rum", [1,6,8,0], () => (__webpack_require__.e(4539).then(() => (() => (__webpack_require__(44539))))))),
	7619: () => (loadStrictVersionCheckFallback("default", "@xsolla/metrika", [4,2,4,1], () => (__webpack_require__.e(1146).then(() => (() => (__webpack_require__(41146))))))),
	8396: () => (loadStrictVersionCheckFallback("default", "formik", [4,2,4,5], () => (Promise.all([__webpack_require__.e(1054), __webpack_require__.e(9494)]).then(() => (() => (__webpack_require__(41054))))))),
	11184: () => (loadStrictVersionCheckFallback("default", "react-text-mask", [4,5,5,0], () => (__webpack_require__.e(8084).then(() => (() => (__webpack_require__(91749))))))),
	18780: () => (loadStrictVersionCheckFallback("default", "react-responsive", [4,9,0,2], () => (__webpack_require__.e(1852).then(() => (() => (__webpack_require__(1852))))))),
	18834: () => (loadSingletonVersionCheckFallback("default", "react-intl", [4,6,5,1], () => (Promise.all([__webpack_require__.e(5213), __webpack_require__.e(9494)]).then(() => (() => (__webpack_require__(55213))))))),
	27330: () => (loadStrictVersionCheckFallback("default", "qs", [1,6,9,6], () => (Promise.all([__webpack_require__.e(129), __webpack_require__.e(4654)]).then(() => (() => (__webpack_require__(80129))))))),
	32621: () => (loadStrictVersionCheckFallback("default", "@xsolla/design-system-navigation", [4,1,27,2], () => (Promise.all([__webpack_require__.e(1337), __webpack_require__.e(3023)]).then(() => (() => (__webpack_require__(1337))))))),
	33063: () => (loadStrictVersionCheckFallback("default", "@datadog/browser-rum-react", [1,6,8,0], () => (__webpack_require__.e(298).then(() => (() => (__webpack_require__(298))))))),
	33847: () => (loadStrictVersionCheckFallback("default", "js-cookie", [1,2,2,1], () => (__webpack_require__.e(6808).then(() => (() => (__webpack_require__(36808))))))),
	42841: () => (loadStrictVersionCheckFallback("default", "oidc-client-ts", [4,3,0,1], () => (Promise.all([__webpack_require__.e(9076), __webpack_require__.e(4038)]).then(() => (() => (__webpack_require__(59076))))))),
	44013: () => (loadStrictVersionCheckFallback("default", "uuid", [1,9,0,1], () => (__webpack_require__.e(7017).then(() => (() => (__webpack_require__(77017))))))),
	56903: () => (loadStrictVersionCheckFallback("default", "axios", [4,1,8,2], () => (__webpack_require__.e(3598).then(() => (() => (__webpack_require__(23598))))))),
	62307: () => (loadStrictVersionCheckFallback("default", "@tanstack/react-query", [4,4,33,0], () => (__webpack_require__.e(7941).then(() => (() => (__webpack_require__(17941))))))),
	62478: () => (loadStrictVersionCheckFallback("default", "@xsolla/login-sdk", [4,0,105,6], () => (__webpack_require__.e(551).then(() => (() => (__webpack_require__(90551))))))),
	65750: () => (loadStrictVersionCheckFallback("default", "color", [1,3,1,3], () => (__webpack_require__.e(6767).then(() => (() => (__webpack_require__(6767))))))),
	74902: () => (loadStrictVersionCheckFallback("default", "configcat-react", [4,4,8,0], () => (__webpack_require__.e(9686).then(() => (() => (__webpack_require__(69686))))))),
	78569: () => (loadStrictVersionCheckFallback("default", "fuse.js", [1,6,4,6], () => (__webpack_require__.e(4221).then(() => (() => (__webpack_require__(74221))))))),
	88155: () => (loadStrictVersionCheckFallback("default", "react-error-boundary", [1,4,0,2], () => (__webpack_require__.e(7630).then(() => (() => (__webpack_require__(4511))))))),
	90334: () => (loadStrictVersionCheckFallback("default", "react-lottie", [1,1,2,4], () => (__webpack_require__.e(9464).then(() => (() => (__webpack_require__(79464))))))),
	92837: () => (loadStrictVersionCheckFallback("default", "react-transition-group", [1,4,4,1], () => (__webpack_require__.e(5773).then(() => (() => (__webpack_require__(65773))))))),
	3023: () => (loadStrictVersionCheckFallback("default", "@xsolla/design-system-utils", [4,1,26,4], () => (Promise.all([__webpack_require__.e(2176), __webpack_require__.e(1469)]).then(() => (() => (__webpack_require__(22176))))))),
	26781: () => (loadStrictVersionCheckFallback("default", "@xsolla/design-system-graphics", [4,1,27,2], () => (__webpack_require__.e(6747).then(() => (() => (__webpack_require__(6747))))))),
	62335: () => (loadStrictVersionCheckFallback("default", "classnames", [1,2,5,1], () => (__webpack_require__.e(3967).then(() => (() => (__webpack_require__(93967))))))),
	11933: () => (loadStrictVersionCheckFallback("default", "react-laag", [1,2,0,5], () => (__webpack_require__.e(2372).then(() => (() => (__webpack_require__(62372))))))),
	19494: () => (loadStrictVersionCheckFallback("default", "react-is", [1,18,2,0], () => (__webpack_require__.e(1296).then(() => (() => (__webpack_require__(21296))))))),
	74038: () => (loadStrictVersionCheckFallback("default", "jwt-decode", [1,3,1,2], () => (__webpack_require__.e(5440).then(() => (() => (__webpack_require__(45440))))))),
	73882: () => (loadStrictVersionCheckFallback("default", "react-is", [1,18,2,0], () => (__webpack_require__.e(9864).then(() => (() => (__webpack_require__(59864))))))),
	64853: () => (loadStrictVersionCheckFallback("default", "use-onclickoutside", [4,0,4,1], () => (__webpack_require__.e(2160).then(() => (() => (__webpack_require__(79790)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"56": [
		10056
	],
	"478": [
		70478
	],
	"866": [
		80866
	],
	"981": [
		64853
	],
	"1352": [
		3191,
		3256,
		7413,
		7619,
		8396,
		11184,
		18780,
		18834,
		27330,
		32621,
		33063,
		33847,
		42841,
		44013,
		56903,
		62307,
		62478,
		65750,
		74902,
		78569,
		88155,
		90334,
		92837
	],
	"1469": [
		61469
	],
	"1664": [
		81664
	],
	"1933": [
		11933
	],
	"2335": [
		62335
	],
	"2747": [
		32747
	],
	"2845": [
		32845
	],
	"3023": [
		3023
	],
	"3745": [
		93745
	],
	"3882": [
		73882
	],
	"4038": [
		74038
	],
	"4666": [
		34666
	],
	"6327": [
		66327
	],
	"6728": [
		36728
	],
	"6781": [
		26781
	],
	"9494": [
		19494
	],
	"9817": [
		79817
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}